import styled from 'styled-components';
import { Button } from '@amzn/storm-ui';

// used for bottom & right sides (left in rtl)
const roundedTopBorderRadius = ({
  theme
}) => `
  /*! @noflip */ border-top-left-radius: ${theme.peekabooStickyTab.borderRadius};
  /*! @noflip */ border-top-right-radius: ${theme.peekabooStickyTab.borderRadius};
  /*! @noflip */ border-bottom-left-radius: 0px;
  /*! @noflip */  border-bottom-right-radius: 0px;
`;

// used for top & left sides (right in rtl)
const roundedBottomBorderRadius = ({
  theme
}) => `
  /*! @noflip */ border-bottom-left-radius: ${theme.peekabooStickyTab.borderRadius};
  /*! @noflip */ border-bottom-right-radius: ${theme.peekabooStickyTab.borderRadius};
  /*! @noflip */ border-top-left-radius: 0px;
  /*! @noflip */ border-top-right-radius: 0px;
`;

// box shadow adjusted for vertical orientation
const verticalOrientationBoxShadow = ({
  theme
}) => `
  /*! @noflip */ box-shadow: ${theme.peekabooStickyTab.verticalBoxShadow};
  :hover {
    /*! @noflip */ box-shadow: ${theme.peekabooStickyTab.hover.verticalBoxShadow};
  }
  :active {
    /*! @noflip */ box-shadow: ${theme.peekabooStickyTab.active.verticalBoxShadow};
  }
`;
const leftStyles = ({
  theme,
  $startOffset,
  $endOffset,
  disabled
}) => `
  /*! @noflip */ right: auto;
  /*! @noflip */ left: 0;
  ${$startOffset ? `
    top: ${$startOffset};
    /*! @noflip */ transform-origin: left top;
    transform: rotate(270deg) translateX(-100%);
  ` : ''}
  ${!$startOffset ? `
    bottom: ${$endOffset};
    /*! @noflip */ transform-origin: left bottom;
    transform: rotate(270deg) translateY(100%);
  ` : ''}
  ${roundedBottomBorderRadius({
  theme
})}
  ${!disabled ? verticalOrientationBoxShadow({
  theme
}) : ''}
`;
const rightStyles = ({
  theme,
  $startOffset,
  $endOffset,
  disabled
}) => `
  /*! @noflip */ left: auto;
  /*! @noflip */ right: 0;
  ${$startOffset ? `
    top: ${$startOffset};
    /*! @noflip */ transform-origin: right top;
    transform: rotate(270deg) translateY(-100%);
  ` : ''}
  ${!$startOffset ? `
    bottom: ${$endOffset};
    /*! @noflip */ transform-origin: right bottom;
    transform: rotate(270deg) translateX(100%);
  ` : ''}
  ${roundedTopBorderRadius({
  theme
})}
  ${!disabled ? verticalOrientationBoxShadow({
  theme
}) : ''}
`;
const PeekabooStickyTabButton = /*#__PURE__*/styled(Button).withConfig({
  componentId: "sc-storm-ui-30062554__sc-uv96h-0"
})(["position:", ";", ";"], ({
  $position
}) => $position, ({
  theme,
  $side,
  $startOffset,
  $endOffset,
  disabled
}) => `
    ${$side === 'top' ? `
      top: 0;
      ${$startOffset ? `
        /*! @noflip */ right: auto;
        /*! @noflip */ left: ${$startOffset}
      ` : ''};
      ${!$startOffset ? `
        /*! @noflip */ left: auto;
        /*! @noflip */ right: ${$endOffset}
      ` : ''};
      ${roundedBottomBorderRadius({
  theme
})}
    ` : ''};
    ${$side === 'bottom' ? `
      bottom: 0;
      ${$startOffset ? `
        /*! @noflip */ right: auto;
        /*! @noflip */ left: ${$startOffset}
      ` : ''};
      ${!$startOffset ? `
        /*! @noflip */ left: auto;
        /*! @noflip */ right: ${$endOffset}
      ` : ''};
      ${roundedTopBorderRadius({
  theme
})}
    ` : ''};
    ${$side === 'start' ? `${leftStyles({
  theme,
  $startOffset,
  $endOffset,
  disabled
})}` : ''};
    ${$side === 'end' ? `${rightStyles({
  theme,
  $startOffset,
  $endOffset,
  disabled
})}` : ''};

    /*! @noflip */
    [dir="rtl"] && {
      ${$side === 'top' ? `
        ${$startOffset ? `
          /*! @noflip */ left: auto;
          /*! @noflip */ right: ${$startOffset}
        ` : ''};
        ${!$startOffset ? `
          /*! @noflip */ right: auto;
          /*! @noflip */ left: ${$endOffset}
        ` : ''};
      ` : ''};
      ${$side === 'bottom' ? `
        bottom: 0;
        ${$startOffset ? `
          /*! @noflip */ left: auto;
          /*! @noflip */ right: ${$startOffset}
        ` : ''};
        ${!$startOffset ? `
          /*! @noflip */ right: auto;
          /*! @noflip */ left: ${$endOffset}
        ` : ''};
      ` : ''};
      ${$side === 'start' ? `${rightStyles({
  theme,
  $startOffset,
  $endOffset,
  disabled
})}` : ''};
      ${$side === 'end' ? `${leftStyles({
  theme,
  $startOffset,
  $endOffset,
  disabled
})}` : ''};
    }
  `);

export { PeekabooStickyTabButton as P };
//# sourceMappingURL=PeekabooStickyTab.styles-DaiKAFBk.js.map
